import { render, staticRenderFns } from "./cxcy.vue?vue&type=template&id=549e36e0&scoped=true"
import script from "./cxcy.vue?vue&type=script&lang=js"
export * from "./cxcy.vue?vue&type=script&lang=js"
import style0 from "./cxcy.vue?vue&type=style&index=0&id=549e36e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549e36e0",
  null
  
)

export default component.exports